import { render, staticRenderFns } from "./GroupFormModal.vue?vue&type=template&id=2dd79562&scoped=true&"
import script from "./GroupFormModal.vue?vue&type=script&lang=js&"
export * from "./GroupFormModal.vue?vue&type=script&lang=js&"
import style0 from "./GroupFormModal.vue?vue&type=style&index=0&id=2dd79562&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dd79562",
  null
  
)

export default component.exports